module.exports = "/assets/f555f4b9642763a5d76c105bda06dfdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/8Q.png
// module id = 2274
// module chunks = 0